module.exports = __webpack_public_path__ + "img/20.3-gallery.62ee98af.jpg";